/* ==========================================================================
   NAOKO: Bottom-sheet filtrów (mobile) — Figma 2844:8004 / 2844:7332
   - drag-to-dismiss (ściągnięcie w dół zamyka)
   - "Pokaż wyniki" zamyka sheet, pokazuje liczbę produktów (tylko gdy są filtry)
   - "Usuń filtry" pokazuje liczbę wszystkich zaznaczonych filtrów; disabled gdy 0
   Filtry stosują się w tle (vendor AJAX) — tu tylko UI liczników + zamykanie.
   ========================================================================== */
(function () {
  'use strict';

  function getFilterDrawer() {
    return document.querySelector(
      '.mobile-facets__wrapper:not(.naoko-sort-drawer-wrapper) .mobile-facets__disclosure'
    );
  }

  function getForm() {
    return document.getElementById('FacetFiltersFormMobile');
  }

  /* ---------------------------------------------------------------- liczniki */

  // Liczba produktów pasujących do aktualnych filtrów — pierwsza liczba
  // w #ProductCount (locale-niezależnie; obsługuje separator tysięcy ze spacją).
  function parseProductCount() {
    var el = document.getElementById('ProductCount') || document.getElementById('ProductCountMobile');
    if (!el) return null;
    var text = (el.textContent || '').replace(/ /g, ' ');
    var match = text.match(/\d[\d\s.]*/);
    if (!match) return null;
    var n = parseInt(match[0].replace(/[^\d]/g, ''), 10);
    return isNaN(n) ? null : n;
  }

  function isPriceActive(form) {
    var active = false;
    var min = form.querySelector('[data-naoko-price-min]');
    var max = form.querySelector('[data-naoko-price-max]');
    if (min) {
      var mv = (min.value || '').trim();
      if (mv !== '' && mv !== '0') active = true;
    }
    if (max) {
      var xv = (max.value || '').trim();
      var rangeMax = (max.dataset.rangeMax || '').trim();
      if (xv !== '' && xv !== rangeMax) active = true;
    }
    return active;
  }

  // Suma wszystkich zaznaczonych filtrów (kolor/rozmiar/materiał = checkboxy,
  // cena liczona jako 1 jeśli ustawiona) — niezależnie od kategorii.
  function countActiveFilters(form) {
    var n = form.querySelectorAll('input[type="checkbox"]:checked').length;
    if (isPriceActive(form)) n += 1;
    return n;
  }

  // fresh=true  -> #ProductCount jest aktualny (wywołanie po renderProductCount/init)
  //                => pokaż realną liczbę produktów.
  // fresh=false -> zmiana w trakcie (input) — NIE pokazuj jeszcze liczby, bo
  //                #ProductCount trzyma starą wartość (uniknięcie migotania
  //                "wszystkie produkty" -> właściwa liczba).
  function updateCounters(fresh) {
    var form = getForm();
    if (!form) return;
    var footer = form.querySelector('.nk-sheet-footer');
    if (!footer) return;

    var active = countActiveFilters(form);

    // "Usuń filtry (n)" + stan disabled — zawsze natychmiast (liczone z checkboxów)
    var clear = footer.querySelector('[data-nk-clear]');
    var clearCount = footer.querySelector('[data-nk-clear-count]');
    if (clearCount) clearCount.textContent = active > 0 ? '(' + active + ')' : '';
    if (clear) {
      if (active > 0) {
        clear.classList.remove('is-disabled');
        clear.removeAttribute('aria-disabled');
        clear.removeAttribute('tabindex');
      } else {
        clear.classList.add('is-disabled');
        clear.setAttribute('aria-disabled', 'true');
        clear.setAttribute('tabindex', '-1');
      }
    }

    // "Pokaż wyniki (n)"
    var resultsCount = footer.querySelector('[data-nk-results-count]');
    if (resultsCount) {
      if (active === 0) {
        // brak filtrów -> bez liczby (natychmiast, w obu trybach)
        resultsCount.textContent = '';
        resultsCount.hidden = true;
      } else if (fresh) {
        // liczba jest aktualna -> pokaż
        var pc = parseProductCount();
        if (pc != null) {
          resultsCount.textContent = '(' + pc + ')';
          resultsCount.hidden = false;
        }
      }
      // fresh=false a active>0: zostaw poprzednią (prawidłową) liczbę bez zmian,
      // realna wartość pojawi się po przeliczeniu AJAX (renderProductCount).
    }

    footer.setAttribute('data-nk-active-filters', String(active));
  }

  /* -------------------------------------------------------------- zamykanie */

  function closeSheet() {
    var details = getFilterDrawer();
    if (!details) return;
    var inner = details.querySelector('.mobile-facets__inner');
    if (inner) {
      inner.classList.remove('nk-dragging');
      inner.style.transform = 'translateY(100%)';
    }
    window.setTimeout(function () {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-mobile');
      if (inner) inner.style.transform = '';
    }, 300);
  }

  /* -------------------------------------------------------- drag-to-dismiss */

  function initDrag() {
    var details = getFilterDrawer();
    if (!details) return;
    var inner = details.querySelector('.mobile-facets__inner');
    var handles = details.querySelectorAll('[data-nk-sheet-grabber], .mobile-facets__header');
    if (!inner || !handles.length) return;

    var startY = 0;
    var delta = 0;
    var dragging = false;

    function onStart(e) {
      var t = e.touches ? e.touches[0] : e;
      startY = t.clientY;
      delta = 0;
      dragging = true;
      inner.classList.add('nk-dragging');
    }

    function onMove(e) {
      if (!dragging) return;
      var t = e.touches ? e.touches[0] : e;
      delta = t.clientY - startY;
      if (delta < 0) delta = 0;
      inner.style.transform = 'translateY(' + delta + 'px)';
      if (delta > 0 && e.cancelable) e.preventDefault();
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      inner.classList.remove('nk-dragging');
      var threshold = Math.min(140, inner.offsetHeight * 0.25);
      if (delta > threshold) {
        inner.style.transform = 'translateY(100%)';
        window.setTimeout(function () {
          details.classList.remove('menu-opening');
          details.removeAttribute('open');
          document.body.classList.remove('overflow-hidden-mobile');
          inner.style.transform = '';
        }, 300);
      } else {
        inner.style.transform = '';
      }
      delta = 0;
    }

    handles.forEach(function (h) {
      h.addEventListener('touchstart', onStart, { passive: true });
      h.addEventListener('touchmove', onMove, { passive: false });
      h.addEventListener('touchend', onEnd);
      h.addEventListener('touchcancel', onEnd);
    });
  }

  /* -------------------------------------------------------------------- init */

  function init() {
    var form = getForm();
    if (form) {
      // zmiana filtra: aktualizuj tylko "Usuń filtry" (liczba produktów dopiero po AJAX)
      form.addEventListener('input', function () { updateCounters(false); });
      form.addEventListener('change', function () { updateCounters(false); });

      var showBtn = form.querySelector('[data-nk-show-results]');
      if (showBtn) {
        showBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closeSheet();
        });
      }
    }

    initDrag();
    updateCounters(true);

    // Hook deterministyczny: po vendorowym renderProductCount #ProductCount jest
    // już aktualny — wtedy (i tylko wtedy) pokazujemy realną liczbę "Pokaż wyniki".
    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderProductCount === 'function' && !FacetFiltersForm._nkCountPatched) {
      var origRenderCount = FacetFiltersForm.renderProductCount;
      FacetFiltersForm.renderProductCount = function (html) {
        origRenderCount.call(this, html);
        updateCounters(true);
      };
      FacetFiltersForm._nkCountPatched = true;
    }

    // Fallback: po AJAX-owym przeładowaniu siatki odśwież stan "Usuń filtry"
    // (na wypadek gdyby serwer zmienił zestaw zaznaczeń).
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      var scheduled = false;
      var observer = new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        window.requestAnimationFrame(function () {
          scheduled = false;
          updateCounters(false);
        });
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
